import React, { useContext, useEffect, useRef } from "react";
import { CartContextData } from "../../context/newsPaperContext";
import { UserDataContext } from "../../context/userContext";
import { toggleSidebar } from "../../globalState/localData";
import { useRecoilState } from "recoil";
import { useBillsOn } from "../Bills/billsOn";
import { useInstallKind } from "../Install/InstallPrompt";
import { getLocalItem } from "../helpers/authService";
import "./menu.css";

// The ☰ menu (2026-10-28 redesign): Browse, Services, home filters, and on phones the reader's account tiles.
// Same actions as before (filterType, frequency and category filters, cookie settings); Pay bills only when switched on.
const PUBLISH_URL = "https://vendor.newstand.tech/register";
const BROWSE = [["Today", "all", "/"], ["Newspapers", "Newspaper", "/"], ["Magazines", "Magazines", "/"], ["Books", "Books", "/"], ["Latest", "Latest", "/"], ["Archive", "achive", "/archive"]];
const FREQ = ["All", "Daily", "Weekly", "Monthly", "Quarterly", "Annually"];
const P = {
  con: "M4 20h4l10-10-4-4L4 16v4zM13.5 6.5l4 4",
  bills: "M13 2L4 14h7l-1 8 9-12h-7l1-8z",
  card: "M3 6h18v12H3zM3 10h18M7 15h4",
  publish: "M4 21V8l8-5 8 5v13M9 21v-6h6v6",
  close: "M6 6l12 12M18 6L6 18",
  library: "M5 4h4v16H5zM10 4h4v16h-4zM15.5 4.5l3.5 1-4 15-3.5-1",
  following: "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM2 21c0-4 3-6 7-6s7 2 7 6M19 8v6M16 11h6",
  subs: "M4 6h16v12H4zM4 10h16",
  payments: "M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8h6M9 12h6",
  apps: "M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h5",
  gift: "M3 8h18v4H3zM5 12v8h14v-8M12 8v12",
};
const Ic = ({ d, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={d} /></svg>
);

export default function Sidebar({ browserRouter, currentRoute }) {
  const { filterType, setfilterType, frequencyType, setFrequencyType, categoriesType, setCategoriesType, UserCatgories } = useContext(CartContextData);
  const { userIsLogin } = useContext(UserDataContext);
  const [sidebarState, setSidebarState] = useRecoilState(toggleSidebar);
  const billsOn = useBillsOn();
  const installKind = useInstallKind();
  const closeRef = useRef(null);

  // The shared state starts as { openSidebar: false } (an object), so test the flag, not the value itself.
  const isOpen = sidebarState === true || Boolean(sidebarState && sidebarState.openSidebar);
  const closeSidebar = () => setSidebarState(false);
  useEffect(() => {
    if (!isOpen) return undefined;
    if (closeRef.current) closeRef.current.focus();
    const onKey = (e) => { if (e.key === "Escape") closeSidebar(); };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const go = (path, filter) => {
    if (filter) setfilterType(filter);
    browserRouter(path);
    closeSidebar();
  };
  const onHome = currentRoute === "/" || currentRoute === "/home";
  const browseOn = (filter) => (filter === "achive" ? /^\/archive/.test(currentRoute || "") : onHome && filterType === filter);
  let user = null;
  try { user = userIsLogin ? JSON.parse(getLocalItem("user")) : null; } catch (e) { user = null; }
  const services = [
    { label: "Change of Name", sub: "Publish your name change in a national paper", icon: P.con, run: () => go("/changeofname") },
    billsOn ? { label: "Pay bills", sub: "Airtime, data, electricity and TV", icon: P.bills, isNew: true, run: () => go("/account/bills") } : null,
    { label: "Redeem a gift card", sub: "Have a TheNewspaperStand card? Add it here", icon: P.card, run: () => go("/o") },
    { label: "Publish on TheNewspaperStand", sub: "For newspapers, magazines and authors", icon: P.publish, href: PUBLISH_URL },
  ].filter(Boolean);
  const chip = (on) => `mn-chip${on ? " on" : ""}`;

  return (
    <>
      <div className={`mn-scrim${isOpen ? " open" : ""}`} onClick={closeSidebar} aria-hidden="true" />
      <nav className={`mn${isOpen ? " open" : ""}`} aria-label="Menu" aria-hidden={!isOpen} {...(!isOpen ? { inert: "" } : {})}>
        <div className="mn-head">
          <span className="mn-title">Menu</span>
          <button type="button" ref={closeRef} className="mn-close" onClick={closeSidebar} aria-label="Close the menu"><Ic d={P.close} size={16} /></button>
        </div>

        <div className="mn-body">
          {userIsLogin && user ? (
            <div className="mn-me mn-phone">
              <div className="mn-me-top">
                <span className="mn-av">{`${(user.firstName || "").charAt(0)}${(user.lastName || "").charAt(0)}`.toUpperCase() || "Me"}</span>
                <span className="mn-me-name">
                  <strong>{`${user.firstName || ""} ${user.lastName || ""}`.trim()}</strong>
                  <button type="button" onClick={() => go("/account")}>My account ›</button>
                </span>
              </div>
              <div className="mn-tiles">
                <button type="button" onClick={() => go("/account/library")}><Ic d={P.library} />Library</button>
                <button type="button" onClick={() => go("/account/library?tab=following")}><Ic d={P.following} />Following</button>
                <button type="button" onClick={() => go("/account/subscriptions")}><Ic d={P.subs} />Subscriptions</button>
                <button type="button" onClick={() => go("/account/payments")}><Ic d={P.payments} />Payments</button>
                <button type="button" onClick={() => go("/account/applications")}><Ic d={P.apps} />Applications</button>
                <button type="button" onClick={() => go("/account/gifts")}><Ic d={P.gift} />Gifts</button>
              </div>
            </div>
          ) : null}

          <div className="mn-sec">
            <span className="mn-label">Browse</span>
            {BROWSE.map(([label, filter, path]) => (
              <button type="button" key={filter} className={`mn-item${browseOn(filter) ? " on" : ""}`} aria-current={browseOn(filter) ? "page" : undefined} onClick={() => go(path, filter)}>{label}</button>
            ))}
          </div>

          <div className="mn-sec">
            <span className="mn-label">Services</span>
            {services.map((s) => {
              const inner = (
                <>
                  <span className="mn-svc-ic"><Ic d={s.icon} /></span>
                  <span className="mn-svc-text">
                    <span className="mn-svc-name">{s.label}{s.isNew ? <em>NEW</em> : null}</span>
                    <span className="mn-svc-sub">{s.sub}</span>
                  </span>
                </>
              );
              return s.href ? (
                <a key={s.label} className="mn-svc" href={s.href} target="_blank" rel="noreferrer" onClick={closeSidebar}>{inner}</a>
              ) : (
                <button type="button" key={s.label} className="mn-svc" onClick={s.run}>{inner}</button>
              );
            })}
          </div>

          <div className="mn-sec mn-filters">
            <span className="mn-label">Filter the home page</span>
            <span className="mn-sub">How often</span>
            <div className="mn-chips">
              {FREQ.map((f) => {
                const v = f === "All" ? "all" : f.toLowerCase();
                return <button type="button" key={f} className={chip(frequencyType === v)} aria-pressed={frequencyType === v} onClick={() => { setFrequencyType(v); go("/"); }}>{f}</button>;
              })}
            </div>
            {UserCatgories && UserCatgories.length ? (
              <>
                <span className="mn-sub">Category</span>
                <div className="mn-chips">
                  <button type="button" className={chip(categoriesType?.id === null)} aria-pressed={categoriesType?.id === null} onClick={() => { setCategoriesType({ id: null }); go("/"); }}>All</button>
                  {UserCatgories.map((c) => (
                    <button type="button" key={c.id} className={chip(categoriesType?.id === c.id)} aria-pressed={categoriesType?.id === c.id} onClick={() => { setCategoriesType(c); go("/"); }}>
                      {c.name.charAt(0).toUpperCase() + c.name.slice(1)}
                    </button>
                  ))}
                </div>
              </>
            ) : null}
          </div>
        </div>

        <div className="mn-foot">
          {userIsLogin ? <button type="button" onClick={() => { closeSidebar(); window.dispatchEvent(new Event("tns:help-open")); }}>Help &amp; support</button> : null}
          {installKind ? <button type="button" onClick={() => { closeSidebar(); window.dispatchEvent(new Event("tns:install-open")); }}>Get the app</button> : null}
          <button
            type="button"
            onClick={() => {
              closeSidebar();
              try { if (window.CookieScript && window.CookieScript.instance) window.CookieScript.instance.show(); } catch (e) { /* not loaded */ }
            }}
          >
            Cookie settings
          </button>
        </div>
      </nav>
    </>
  );
}
